(function(ns) {
	"use strict";

	var d = document;

	var rootE = d.querySelector("#js-maman-entry-replace");

	if (!isSupported() || !rootE) {
		return;
	}

	initLoading();
	ns.initApp(rootE);

	function initLoading() {
		[].forEach.call(rootE.querySelectorAll(".js-not-supported"), function(el) {
			el.parentNode.removeChild(el);
		});

		var loadingMessage = d.createElement("div");
		loadingMessage.className = "js-loading";
		loadingMessage.appendChild(d.createTextNode("読み込み中..."))
		rootE.appendChild(loadingMessage);
	}

	function isSupported() {
		if (typeof (1).toLocaleString !== "function") {
			return false;
		}
		if (typeof [].map !== "function") {
			return false;
		}
		if (!window.localStorage || !window.sessionStorage) {
			return false;
		}
		return true;
	}

})(UE);
